(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewPositionsReport.controller:CrewPositionsReport
	 *
	 * @description
	 *
	 */
	angular
		.module('crewPositionsReport')
			.directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
		.controller('CrewPositionsReportCtrl',CrewPositionsReportCtrl);

	function CrewPositionsReportCtrl(CommonMasterData, crewScheduleService,RemoteService,$sce,MessageService, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'CrewPositionsReportCtrl';

		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewId : null,
				datePickerOption : {maxDate : new Date()}
			},
			masterList : {
				fromDateAfterToDate : false,
				isCrewAvailable : true,
				fromDateToDateAfterToDay : false,
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl :null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchCrewPositionsReport(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			if(flag == 'fromDate'&& !!searchParams.fromDate){
				var monthEnd = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
				if(isDateBeforeCurrentDate(monthEnd)){
					searchParams.toDate = monthEnd;
				} else {
					searchParams.toDate = moment().format("DD/MM/YYYY");
				}
			}
			setDateValidationFlags();
		};

		function setDateValidationFlags(){
			//if from date invalid
			vm.model.masterList.fromDateFormatInvalid = isDateFormatInvalid(vm.model.searchCriteria.fromDate);
			vm.model.masterList.toDateFormatInvalid = isDateFormatInvalid(vm.model.searchCriteria.toDate);
			vm.model.masterList.fromDateAfterToDate = (!vm.model.masterList.toDateFormatInvalid && !vm.model.masterList.fromDateFormatInvalid &&
					istoDateBeforeFromDate()) ? true : false;
			vm.model.masterList.fromDateToDateAfterToDay = (!vm.model.masterList.fromDateAfterToDate &&
					((!vm.model.masterList.fromDateFormatInvalid
							&& !isDateBeforeCurrentDate(vm.model.searchCriteria.fromDate)) ||
							( !vm.model.masterList.toDateFormatInvalid && !isDateBeforeCurrentDate(vm.model.searchCriteria.toDate)))) ? true : false;
		}

		function isDateFormatInvalid(date){
			if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
				return true;
			}
			return false;
		}


		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		function isDateBeforeCurrentDate(strDate){
			if(moment(strDate, "DD/MM/YYYY")
					.isAfter(new Date())){
				return false;
			}
			return true;

		}

		function searchCrewPositionsReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
		    	var url = CommonLogicService.getReportUrl('crew_position.rptdesign',getSearchParamMap(param));
		    	vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		//set search param map
		function getSearchParamMap(param){
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			if(!!param.crewId){
				searchParamMap["crewId"] = param.crewId;
			}
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if(vm.model.masterList.toDateFormatInvalid || vm.model.masterList.fromDateFormatInvalid){
				return false;
			}
			if(!isDateBeforeCurrentDate(params.toDate) || !isDateBeforeCurrentDate(params.fromDate)){
				vm.model.masterList.fromDateToDateAfterToDay = true;
				vm.model.masterList.fromDateAfterToDate = false;
				vm.model.masterList.isCrewAvailable = true;
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateToDateAfterToDay = false;
				vm.model.masterList.fromDateAfterToDate = true;
				vm.model.masterList.isCrewAvailable = true;
				return false;
			} else {
				vm.model.masterList.fromDateToDateAfterToDay = false;
				vm.model.masterList.fromDateAfterToDate = false;
				if (((vm.model.searchCriteria.crewId != null && vm.model.searchCriteria.crewId != ''))) {
					vm.model.masterList.isCrewAvailable = true;
				} else {
					vm.model.masterList.isCrewAvailable = false;
					return false;
				}
			}
			return true;
		};
	}
}());
